import { defaultTypeOfDanger, defaultFilterSgaTypesOfDanger } from "./state";

/**
 * Mutación que lista los tipos de peligro de SGA .
 *
 * @param {*} state.typesOfDangers - Estado de los tipo de peligro de SGA.
 * @param typesOfDangers - Tipos de peligro de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setTypeOfDangersSga(state, typesOfDangers) {
    state.typesOfDangers = typesOfDangers;
}

/**
 * Mutación que establece la acción a realizar.
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar.
 * @return {void}
 * @author Brandon Torres
 */
export function setActionTypeOfDanger(state, action) {
    state.action = action;
}

/**
 * Mutación que establece el tipo de peligro por defecto.
 *
 * @param {*} state.typeOfDanger - Estado del tipo de peligro.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultTypeOfDangerSga(state) {
    state.typeOfDanger = defaultTypeOfDanger();
}

/**
 * Mutación que establece el filtro de tipos de peligros de SGA por defecto.
 *
 * @param {*} state.filterTypesOfDangersSga - Estado del filtro de tipos de peligros de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterSgaTypesOfDangers(state) {
    state.filterTypesOfDangersSga = defaultFilterSgaTypesOfDanger();
}

/**
 * Mutación que establece la cantidad de tipos de peligro por página.
 *
 * @param per_page - Cambio de cantidad de registros por página.
 * @param {*} state.filterTypesOfDangersSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterTypesOfDangersSga.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterTypesOfDangersSga = {
        ...state.filterTypesOfDangersSga,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param page - Cambio de página actual.
 * @param {*} state.filterTypesOfDangersSga.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterTypesOfDangersSga.page = page;
}

/**
 * Mutación que establece el paginador de registros de tipos de peligro.
 *
 * @param paginate - Paginación de registros.
 * @param {*} state.filterTypesOfDangersSga.page - Página actual.
 * @param {*} state.filterTypesOfDangersSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterTypesOfDangersSga.total - Total de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateTypeOfDangersSga(state, paginate) {
    state.filterTypesOfDangersSga = {
        ...state.filterTypesOfDangersSga,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece el tipo de peligro de SGA.
 *
 * @param {*} state.typeOfDanger - Estado del tipo de peligro.
 * @param typeOfDanger - Tipo de peligro de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setTypeOfDangerSga(state, typeOfDanger) {
    state.typeOfDanger = {
        id: typeOfDanger.id,
        name: typeOfDanger.name,
        version_id: typeOfDanger.version_id,
        color: typeOfDanger.color,
        priority: typeOfDanger.priority,
        sga_type_of_danger_languages: typeOfDanger.sga_type_of_danger_languages,
    };
}

/**
 * Mutación que establece los tipos de peligros activos de SGA.
 *
 * @param {*} state.activeTypesOfDangers - Estado de tipos de peligros activos de SGA.
 * @param activeTypesOfDangers - Tipos de peligros activos de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setActiveTypesOfDangersSga(state, activeTypesOfDangers) {
    state.activeTypesOfDangers = activeTypesOfDangers;
}
